export default __webpack_public_path__ + "static/media/cockroach-labs.1f86ecea.png";